// frontend/admin-portal/src/services/treasuryService.js
import api from './axiosConfig';

export const treasuryService = {
    dashboard: async () => {
        const { data } = await api.get('/treasury/dashboard');
        return data.data;
    },
    babylon: async (days = 30) => {
        const { data } = await api.get(`/treasury/babylon?days=${days}`);
        return data.data;
    },

    listAccounts: async () => {
        const { data } = await api.get('/treasury/accounts');
        return data.data;
    },
    createAccount: async (payload) => {
        const { data } = await api.post('/treasury/accounts', payload);
        return data.data.account;
    },
    updateAccount: async (id, payload) => {
        const { data } = await api.put(`/treasury/accounts/${id}`, payload);
        return data.data.account;
    },
    removeAccount: async (id) => {
        const { data } = await api.delete(`/treasury/accounts/${id}`);
        return data;
    },

    listTransactions: async (params = {}) => {
        const { data } = await api.get('/treasury/transactions', { params });
        return data.data;
    },
    createTransaction: async (payload) => {
        const { data } = await api.post('/treasury/transactions', payload);
        return data.data.transaction;
    },
    deleteTransaction: async (id) => {
        const { data } = await api.delete(`/treasury/transactions/${id}`);
        return data;
    },

    listCategories: async (params = {}) => {
        const { data } = await api.get('/treasury/categories', { params });
        return data.data.categories;
    },
    
    profit: async (params = {}) => {
        const { data } = await api.get('/treasury/profit', { params });
        return data.data;
    },
};